




import { Component, Vue } from "vue-property-decorator";
import { Staff, getOurStaffs } from "@/api/company-api";
import { addServiceUserStaff } from "@/api/invitation-api";
import { getServiceUsers, ServiceUser } from "@/api/service-api";
import InvitableStaffSpec from "@/models/specs/InvitableStaffSpec";

import StaffList from "@/templates/StaffList.vue";
import { StaffTableItem } from "@/components/VStaffTable.vue";

@Component({
  components: {
    StaffList
  }
})
export default class OurStaffListPage extends Vue {
  query = "";

  select(id: number) {
    const params = { id: String(id) };
    this.$router.push({ name: "our-staff-edit", params });
  }

  create() {
    this.$router.push({ name: "our-staff-new" });
  }

  search(query: string) {
    this.query = query;
  }

  async invite(id: number) {
    const s = this.staffs.find(s => s.staffId === id);
    if (!s) return;
    try {
      await addServiceUserStaff(s.staffId);
    } catch (e) {
      alert(e);
      return;
    }
    await this.initServiceUsers();
  }

  private staffs: Staff[] = [];
  private serviceUsers: ServiceUser[] = [];

  private get filteredStaff() {
    // TODO: API側で絞り込んだ方がいい
    if (!this.query) return this.staffs;
    return this.staffs.filter(s => s.name.includes(this.query));
  }

  get items(): StaffTableItem[] {
    return this.filteredStaff.map(
      s =>
        new StaffTableItem(
          s,
          (s as any).company,
          this.invitableSpec.isSatisfied(s)
        )
    );
  }

  private get invitableSpec() {
    return new InvitableStaffSpec(this.serviceUsers);
  }

  private async created() {
    this.initStaffs();
    this.initServiceUsers();
  }

  private async initStaffs() {
    this.staffs = await getOurStaffs();
  }

  private async initServiceUsers() {
    this.serviceUsers = await getServiceUsers();
  }
}
